module.exports = __webpack_public_path__ + "img/title-container-background-start.f461a9bd.png";